import script from "./SearchFrame.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFrame.vue?vue&type=script&lang=ts&setup=true"

import "./SearchFrame.vue?vue&type=style&index=0&id=4b07fd96&lang=scss&scoped=true"
import "./SearchFrame.vue?vue&type=style&index=1&id=4b07fd96&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b07fd96"]])

export default __exports__